import { Add } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'

interface Props extends ButtonProps {
  id: string
  buttonText: string
}

export const AddButton = ({ id, buttonText, ...props }: Props) => {
  return (
    <Button
      id={id + '-button'}
      sx={{ marginTop: 0, marginBottom: -1 }}
      color="secondary"
      disableElevation
      size="small"
      variant="text"
      endIcon={<Add />}
      {...props}
    >
      {buttonText}
    </Button>
  )
}
